//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

export enum AfterEventCancellationDeadlineAction {
    AbsentMakeup = "AbsentMakeup",
    AbsentNoMakeup = "AbsentNoMakeup"
}
export enum ApiKeyMode {
    Read = "Read",
    ReadWrite = "ReadWrite"
}
export enum AttachmentBehaviour {
    Image = "Image",
    PDF = "PDF",
    Playable = "Playable",
    None = "None"
}
export enum AttachmentStyle {
    Attached = "Attached",
    Inline = "Inline"
}
export enum AttendanceMakeupCreditIssue {
    AtMax = "AtMax",
    NotEnough = "NotEnough",
    Required = "Required",
    NotAllowed = "NotAllowed",
    SchoolEvent = "SchoolEvent"
}
export enum AttendanceNoteType {
    Student = "Student",
    Parent = "Parent",
    Private = "Private"
}
export enum AttendanceStatus {
    Unrecorded = "Unrecorded",
    PresentMakeup = "PresentMakeup",
    Present = "Present",
    PresentLate = "PresentLate",
    PresentLateMakeUp = "PresentLateMakeUp",
    AbsentMakeup = "AbsentMakeup",
    AbsentUseMakeup = "AbsentUseMakeup",
    AbsentNoMakeup = "AbsentNoMakeup",
    AbsentNotice = "AbsentNotice",
    TeacherAbsentMakeup = "TeacherAbsentMakeup",
    TeacherAbsentNoMakeup = "TeacherAbsentNoMakeup"
}
export enum BalanceDateType {
    Today = "Today",
    EndOfMonth = "EndOfMonth",
    DayOfMonth = "DayOfMonth",
    SpecificDate = "SpecificDate"
}
export enum BankAccountHolderType {
    Personal = "Personal",
    Business = "Business"
}
export enum BeforeEventCancellationDeadlineAction {
    AbsentMakeup = "AbsentMakeup",
    AbsentNotice = "AbsentNotice",
    RemoveStudent = "RemoveStudent",
    AbsentNoMakeup = "AbsentNoMakeup"
}
export enum BillableHoursReportDetailLevel {
    Teacher = "Teacher",
    EventCategory = "EventCategory",
    IndividualEvent = "IndividualEvent"
}
export enum BillingProfileDefaultMode {
    None = "None",
    PerLesson = "PerLesson",
    Hourly = "Hourly",
    FixedMonthly = "FixedMonthly"
}
export enum BlockedRecipientType {
    None = "None",
    Temporary = "Temporary",
    Permanent = "Permanent"
}
export enum BookingPriceOverrideType {
    None = "None",
    FixedAmount = "FixedAmount",
    FixedDiscount = "FixedDiscount",
    PercentageDiscount = "PercentageDiscount"
}
export enum CallInitiationType {
    None = "None",
    Teacher = "Teacher",
    Student = "Student",
    Both = "Both"
}
export enum CalendarAgendaMode {
    Agenda = "Agenda",
    Basic = "Basic",
    List = "List"
}
export enum CalendarColorMode {
    EventCategory = "EventCategory",
    Teacher = "Teacher",
    Location = "Location"
}
export enum CalendarDragAndDropMode {
    ChangeTeacher = "ChangeTeacher",
    Substitute = "Substitute"
}
export enum CalendarEventUpdateStudentChangeMode {
    Absolute = "Absolute",
    Delta = "Delta"
}
export enum CalendarEventUpdateNotAllowedReason {
    EventsHaveStudentsNotAssignedToTeacher = "EventsHaveStudentsNotAssignedToTeacher",
    SingleEventUpdateRepeatDetailsDoNotMatch = "SingleEventUpdateRepeatDetailsDoNotMatch"
}
export enum CalendarFeedConsumer {
    iOS = "iOS",
    OSX = "OSX",
    GoogleCalendar = "GoogleCalendar",
    OutlookOnline = "OutlookOnline",
    OutlookDesktop = "OutlookDesktop",
    BlackBerry = "BlackBerry"
}
export enum CalendarFeedFreeBusyMode {
    None = "None",
    AllBusy = "AllBusy",
    FreeWhenCanJoin = "FreeWhenCanJoin"
}
export enum CalendarMonthMode {
    Expanded = "Expanded",
    Condensed = "Condensed"
}
export enum CalendarReportGroupBy {
    EventLocation = "EventLocation",
    Teacher = "Teacher"
}
export enum CalendarResourceMode {
    Teacher = "Teacher",
    Location = "Location"
}
export enum CalendarViewMode {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Timeline = "Timeline"
}
export enum CancellationConversionPolicy {
    None = "None",
    Open = "Open",
    MakeUp = "MakeUp"
}
export enum CardOnFileType {
    No = "No",
    Yes = "Yes",
    AutoPay = "AutoPay"
}
export enum TransactionSource {
    Manual = "Manual",
    FixedMonthly = "FixedMonthly",
    Calendar = "Calendar",
    Package = "Package"
}
export enum CashType {
    Revenue = "Revenue",
    Expense = "Expense",
    RefundedRevenue = "RefundedRevenue",
    RefundedExpense = "RefundedExpense"
}
export enum CashCategorySearchType {
    Revenue = "Revenue",
    Expense = "Expense"
}
export enum ChangePasswordResult {
    CurrentPasswordDoesNotMatch = "CurrentPasswordDoesNotMatch",
    PasswordChanged = "PasswordChanged"
}
export enum CreditCardBrand {
    Amex = "Amex",
    DinersClub = "DinersClub",
    Discover = "Discover",
    EuroCard = "EuroCard",
    JCB = "JCB",
    Maestro = "Maestro",
    Mastercard = "Mastercard",
    Visa = "Visa"
}
export enum CustomFieldType {
    CheckedList = "CheckedList",
    Date = "Date",
    DropDownList = "DropDownList",
    Email = "Email",
    MultiLine = "MultiLine",
    Policy = "Policy",
    RadioList = "RadioList",
    Text = "Text"
}
export enum DayOfWeekEnum {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday"
}
export enum DistanceUnit {
    Miles = "Miles",
    Kilometers = "Kilometers"
}
export enum DkimResult {
    OK = "OK",
    NotFound = "NotFound",
    Misconfigured = "Misconfigured"
}
export enum EmailSender {
    Teacher = "Teacher",
    School = "School"
}
export enum EmailTemplateType {
    Custom = "Custom",
    FirstBookingConfirmation = "FirstBookingConfirmation",
    Login = "Login",
    Invoice = "Invoice",
    InvoiceReminder = "InvoiceReminder",
    Payment = "Payment",
    Refund = "Refund",
    LessonNotes = "LessonNotes",
    EventReminder = "EventReminder",
    Birthday = "Birthday",
    NewOnlineItem = "NewOnlineItem",
    CancelledEvent = "CancelledEvent",
    AutoPayFailed = "AutoPayFailed",
    BankTransferFailed = "BankTransferFailed",
    SignUpConfirmation = "SignUpConfirmation",
    TeacherLoginSetup = "TeacherLoginSetup"
}
export enum ErrorCode {
    None = "None",
    Aggregate = "Aggregate",
    AdultStudentParentAlreadyLinkedToOtherAdultStudent = "AdultStudentParentAlreadyLinkedToOtherAdultStudent",
    AdultStudentParentInDifferentFamily = "AdultStudentParentInDifferentFamily",
    AtLeastOneActiveTeacherMustExist = "AtLeastOneActiveTeacherMustExist",
    AtLeastOneActiveAdministratorMustExist = "AtLeastOneActiveAdministratorMustExist",
    AtLeastOneActiveTeacherWhoIsTeacherMustExist = "AtLeastOneActiveTeacherWhoIsTeacherMustExist",
    AttendanceAttachmentAlreadyExists = "AttendanceAttachmentAlreadyExists",
    BankAccountAlreadyExists = "BankAccountAlreadyExists",
    BookingFailed = "BookingFailed",
    CannotCancelEvent = "CannotCancelEvent",
    CannotDelete = "CannotDelete",
    CannotDeleteBecauseDependenciesExist = "CannotDeleteBecauseDependenciesExist",
    CannotJoinEvent = "CannotJoinEvent",
    CalendarHasUpdateRequirements = "CalendarHasUpdateRequirements",
    Captcha = "Captcha",
    CashCategoryAlreadyExists = "CashCategoryAlreadyExists",
    CreditCardAlreadyExists = "CreditCardAlreadyExists",
    ClaimNotFound = "ClaimNotFound",
    DataEmpty = "DataEmpty",
    DataTooLarge = "DataTooLarge",
    DuplicatePaymentProcessorTransaction = "DuplicatePaymentProcessorTransaction",
    DuplicateApiKey = "DuplicateApiKey",
    DuplicateWebhook = "DuplicateWebhook",
    DuplicateExternalCalendarFeed = "DuplicateExternalCalendarFeed",
    EmailAddressInvalid = "EmailAddressInvalid",
    EmailUnavailable = "EmailUnavailable",
    EntityNotFound = "EntityNotFound",
    EventCategoryAlreadyExists = "EventCategoryAlreadyExists",
    EventLocationAlreadyExists = "EventLocationAlreadyExists",
    FileEmpty = "FileEmpty",
    FileTooLarge = "FileTooLarge",
    ImportDataInvalid = "ImportDataInvalid",
    InputDataInvalid = "InputDataInvalid",
    MaxActiveTeacherCountExceeded = "MaxActiveTeacherCountExceeded",
    MaxEmailRecipientsExceeded = "MaxEmailRecipientsExceeded",
    MembershipSubscriptionError = "MembershipSubscriptionError",
    MessageCannotBeDeletedBecauseItHasAlreadyBeenSent = "MessageCannotBeDeletedBecauseItHasAlreadyBeenSent",
    OnlinePaymentError = "OnlinePaymentError",
    PackageDefinitionAlreadyExists = "PackageDefinitionAlreadyExists",
    PackageDefinitionAssignmentAlreadyExists = "PackageDefinitionAssignmentAlreadyExists",
    ParameterNullOrWhiteSpace = "ParameterNullOrWhiteSpace",
    PaymentProcessorError = "PaymentProcessorError",
    PaymentSourceNotSupported = "PaymentSourceNotSupported",
    PaymentSourceRequired = "PaymentSourceRequired",
    Placeholder = "Placeholder",
    PropertyLengthExceeded = "PropertyLengthExceeded",
    PropertyRequired = "PropertyRequired",
    ReviewAlreadyExists = "ReviewAlreadyExists",
    SchoolAlreadySubscribed = "SchoolAlreadySubscribed",
    SchoolNotSubscribed = "SchoolNotSubscribed",
    StudentCalendarConflict = "StudentCalendarConflict",
    TagAlreadyExists = "TagAlreadyExists",
    TeacherCannotDeleteSelf = "TeacherCannotDeleteSelf",
    TeacherCannotMakeSelfInactive = "TeacherCannotMakeSelfInactive",
    TeacherCannotMakeSelfNonAdministrator = "TeacherCannotMakeSelfNonAdministrator",
    TransactionNotFound = "TransactionNotFound",
    Unknown = "Unknown",
    UnparseableID = "UnparseableID"
}
export enum EventCategorySearchType {
    EventCategories = "EventCategories",
    TransactionCategories = "TransactionCategories"
}
export enum EventColorEnum {
    Beach = "Beach",
    Black = "Black",
    Blue = "Blue",
    Brown = "Brown",
    DarkOrange = "DarkOrange",
    Gray = "Gray",
    Green = "Green",
    GrassGreen = "GrassGreen",
    Lavender = "Lavender",
    LightGrey = "LightGrey",
    LightPink = "LightPink",
    Lime = "Lime",
    Magenta = "Magenta",
    Mint = "Mint",
    Olive = "Olive",
    Orange = "Orange",
    Pink = "Pink",
    Purple = "Purple",
    Red = "Red",
    Royal = "Royal",
    Ruby = "Ruby",
    Salmon = "Salmon",
    SeaBlue = "SeaBlue",
    Tan = "Tan",
    Tangerine = "Tangerine",
    Teal = "Teal",
    Yellow = "Yellow",
    White = "White"
}
export enum EventDeletionLogReason {
    AllEventsOnADay = "AllEventsOnADay",
    DestructiveUpdate = "DestructiveUpdate",
    IndividualEvent = "IndividualEvent",
    RecurringEventChange = "RecurringEventChange"
}
export enum EventDeletionType {
    All = "All",
    Future = "Future",
    One = "One"
}
export enum EventKind {
    Calendar = "Calendar",
    Repertoire = "Repertoire"
}
export enum EventLocationIcon {
    None = "None",
    Home = "Home",
    Studio = "Studio",
    School = "School",
    Institution = "Institution",
    Car = "Car",
    Church = "Church",
    Mosque = "Mosque",
    Synagogue = "Synagogue",
    HinduTemple = "HinduTemple",
    Skype = "Skype",
    Video = "Video"
}
export enum EventType {
    IndividualEvent = "IndividualEvent",
    FixedMonthlyChargeEvent = "FixedMonthlyChargeEvent",
    NonCalendarChargeEvent = "NonCalendarChargeEvent",
    PayrollEvent = "PayrollEvent",
    PackageChargeEvent = "PackageChargeEvent",
    PackageExpiryEvent = "PackageExpiryEvent"
}
export enum FamilyAccountBalanceReportSortBy {
    Balance = "Balance",
    Name = "Name"
}
export enum FieldMode {
    NotPresent = "NotPresent",
    Optional = "Optional",
    Required = "Required"
}
export enum FormAffinity {
    Form = "Form",
    Student = "Student"
}
export enum RecurringAttendanceCreateMode {
    None = "None",
    All = "All",
    NoConflicts = "NoConflicts"
}
export enum InvoiceEmailType {
    Invoice = "Invoice",
    Reminder = "Reminder"
}
export enum InvoiceFormat {
    Expanded = "Expanded",
    Normal = "Normal",
    Condensed = "Condensed"
}
export enum InvoiceMode {
    Prepaid = "Prepaid",
    Postpaid = "Postpaid"
}
export enum InvoiceStatus {
    Void = "Void",
    Open = "Open",
    Paid = "Paid"
}
export enum LessonsTaughtReportGroupBy {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Quarter = "Quarter",
    Year = "Year",
    Student = "Student"
}
export enum WhiteboardSpaceMode {
    EventSeries = "EventSeries",
    Students = "Students"
}
export enum LocationAddressType {
    None = "None",
    StudentsHome = "StudentsHome",
    BasicAddress = "BasicAddress",
    Skype = "Skype",
    Zoom = "Zoom",
    FaceTime = "FaceTime",
    Lessonspace = "Lessonspace",
    PencilSpaces = "PencilSpaces"
}
export enum LoginAccessStatus {
    NoAccess = "NoAccess",
    Access_ResetToken = "Access_ResetToken",
    Access_Password = "Access_Password"
}
export enum MakeUpCreditsReportDetailLevel {
    EventCategory = "EventCategory",
    IndividualEvent = "IndividualEvent",
    Student = "Student"
}
export enum MakeUpUnavailableReason {
    None = "None",
    InsufficientCredits = "InsufficientCredits",
    MakeUpDisabled = "MakeUpDisabled",
    SchoolEvent = "SchoolEvent"
}
export enum MembershipPaymentProcessor {
    None = "None",
    PayPal = "PayPal",
    Stripe = "Stripe"
}
export enum MediaType {
    Image = "Image",
    PDF = "PDF",
    Video = "Video",
    Audio = "Audio",
    Icon = "Icon",
    HTML = "HTML",
    CSS = "CSS",
    Other = "Other"
}
export enum MembershipPlanCurrencyCode {
    AUD = "AUD",
    CAD = "CAD",
    EUR = "EUR",
    GBP = "GBP",
    NZD = "NZD",
    USD = "USD"
}
export enum MembershipSubscriptionStatus {
    Active = "Active",
    Cancelled = "Cancelled",
    NotSubscribed = "NotSubscribed",
    PastDue = "PastDue",
    Trial = "Trial"
}
export enum MembershipTransactionType {
    Payment = "Payment",
    Refund = "Refund"
}
export enum MessageMethod {
    Email = "Email",
    SMS = "SMS",
    Telephone = "Telephone"
}
export enum MessageStatus {
    Bounced = "Bounced",
    Queued = "Queued",
    Scheduled = "Scheduled",
    Sent = "Sent",
    MarkedAsSpam = "MarkedAsSpam",
    Blocked = "Blocked",
    Failed = "Failed",
    Spam = "Spam"
}
export enum MfaSetupResult {
    Success = "Success",
    IncorrectCode = "IncorrectCode",
    AlreadySetup = "AlreadySetup"
}
export enum NameFormat {
    LastCommaFirst = "LastCommaFirst",
    FirstLast = "FirstLast",
    LastFirst = "LastFirst"
}
export enum NavigationItemState {
    Show = "Show",
    Hidden = "Hidden",
    Disabled = "Disabled"
}
export enum NewsPostIconEnum {
    Airplane = "Airplane",
    Bell = "Bell",
    BirthdayCake = "BirthdayCake",
    Book = "Book",
    Bullhorn = "Bullhorn",
    Cake = "Cake",
    Calendar = "Calendar",
    Camera = "Camera",
    Checkmark = "Checkmark",
    Clock = "Clock",
    Flash = "Flash",
    Gift = "Gift",
    Globe = "Globe",
    GraduationCap = "GraduationCap",
    Heart = "Heart",
    Lightbulb = "Lightbulb",
    Newspaper = "Newspaper",
    Microphone = "Microphone",
    Money = "Money",
    Music = "Music",
    Recycle = "Recycle",
    Smile = "Smile",
    SpeechBubble = "SpeechBubble",
    Star = "Star",
    ThumbsUp = "ThumbsUp",
    Youtube = "Youtube"
}
export enum OnlineResourceBehaviour {
    None = "None",
    Playable = "Playable",
    Viewable = "Viewable",
    Folder = "Folder"
}
export enum OnlineResourceType {
    File = "File",
    Folder = "Folder"
}
export enum OptionalFieldInclusion {
    Include = "Include",
    Exclude = "Exclude"
}
export enum OrderByDirection {
    Ascending = "Ascending",
    Descending = "Descending"
}
export enum PackageExpiryType {
    None = "None",
    AfterPurchase = "AfterPurchase"
}
export enum PackageLedgerEntryType {
    Purchase = "Purchase",
    Usage = "Usage",
    Expiry = "Expiry"
}
export enum PackageStatus {
    Active = "Active",
    Inactive = "Inactive"
}
export enum PackageVisibility {
    None = "None",
    StudentPortal = "StudentPortal",
    Widget = "Widget",
    All = "All"
}
export enum PaymentProcessorType {
    PayPalPro = "PayPalPro",
    PayPalCommercePlatform = "PayPalCommercePlatform",
    Stripe = "Stripe"
}
export enum PaymentSourceType {
    BankAccount = "BankAccount",
    CreditCard = "CreditCard",
    StripeLink = "StripeLink",
    Venmo = "Venmo",
    PayPal = "PayPal",
    iDEAL = "iDEAL",
    Alipay = "Alipay",
    WechatPay = "WechatPay",
    Klarna = "Klarna"
}
export enum PaymentSourceIntent {
    Pay = "Pay",
    Vault = "Vault",
    PayAndVault = "PayAndVault",
    VaultByRefund = "VaultByRefund"
}
export enum PaymentMethod {
    PayPal = "PayPal",
    CreditCard = "CreditCard",
    ACH = "ACH"
}
export enum PaymentProcessorState {
    Inactive = "Inactive",
    Pending = "Pending",
    Active = "Active"
}
export enum PaymentReturnStatus {
    Cancelled = "Cancelled",
    ExpressCheckoutCompleted = "ExpressCheckoutCompleted",
    PayPalStandardCompleted = "PayPalStandardCompleted",
    PayPalCompleted = "PayPalCompleted",
    StripeCompleted = "StripeCompleted"
}
export enum PayPalCommercePlatformPartnerReferralLinkType {
    Express = "Express",
    Vaulting = "Vaulting"
}
export enum PaymentSourceRegistrationNextAction {
    None = "None",
    CollectPayment = "CollectPayment",
    UseStripeSdk = "UseStripeSdk",
    RedirectToUrl = "RedirectToUrl"
}
export enum PayrollOverrideType {
    None = "None",
    Percent = "Percent",
    UpliftFixed = "UpliftFixed",
    PerStudent = "PerStudent",
    PerHour = "PerHour",
    PerHourWithoutAttn = "PerHourWithoutAttn"
}
export enum PayrollSourceType {
    Manual = "Manual",
    Teacher = "Teacher",
    EventCategory = "EventCategory",
    TeacherOverride = "TeacherOverride"
}
export enum PayrollType {
    Income = "Income",
    Deduction = "Deduction",
    Payment = "Payment",
    Return = "Return"
}
export enum PortalType {
    StudentPortal = "StudentPortal",
    TeacherPortal = "TeacherPortal"
}
export enum PracticeLogType {
    Feedback = "Feedback",
    Submission = "Submission"
}
export enum PracticeLogNotificationType {
    Added = "Added",
    Updated = "Updated"
}
export enum PracticeLogSummaryReportSortBy {
    NumberOfEntries = "NumberOfEntries",
    StudentName = "StudentName",
    TotalTime = "TotalTime"
}
export enum PreviousAttendanceFetchMode {
    Any = "Any",
    EventCategory = "EventCategory"
}
export enum PricePerParticipantUnit {
    PackageMinutes = "PackageMinutes",
    PerEvent = "PerEvent",
    PerMonth = "PerMonth"
}
export enum PricePerParticipantTypeEnum {
    ParticipantDefaultPrice = "ParticipantDefaultPrice",
    NoCharge = "NoCharge",
    SpecifiedPrice = "SpecifiedPrice"
}
export enum ProfileType {
    Teacher = "Teacher",
    AdultStudent = "AdultStudent",
    ChildStudent = "ChildStudent",
    Parent = "Parent"
}
export enum ProfileMode {
    Parent = "Parent",
    Student = "Student",
    Teacher = "Teacher",
    ApiKey = "ApiKey",
    Widget = "Widget"
}
export enum ReceiptEmailType {
    Payment = "Payment",
    Refund = "Refund"
}
export enum RegistrationEligibility {
    Open = "Open",
    AlreadyAttending = "AlreadyAttending",
    NoRegistration = "NoRegistration",
    RegistrationDisabled = "RegistrationDisabled",
    DeadlinePassed = "DeadlinePassed",
    EventFull = "EventFull",
    InsufficientMakeUpCredits = "InsufficientMakeUpCredits"
}
export enum SignupPaymentType {
    Fees = "Fees",
    Deposit = "Deposit"
}
export enum RegistrationStatus {
    Success = "Success",
    AlreadyAttending = "AlreadyAttending",
    NoRegistration = "NoRegistration",
    RegistrationDisabled = "RegistrationDisabled",
    DeadlinePassed = "DeadlinePassed",
    EventFull = "EventFull",
    InsufficientMakeUpCredits = "InsufficientMakeUpCredits",
    Conflicted = "Conflicted",
    UnableToCancel = "UnableToCancel"
}
export enum RemittanceType {
    Remittance = "Remittance",
    Refund = "Refund"
}
export enum RepState {
    Active = "Active",
    Inactive = "Inactive",
    Incomplete = "Incomplete"
}
export enum RepeatFrequencyEnum {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
    Yearly = "Yearly"
}
export enum RepeatMonthTypeEnum {
    Absolute = "Absolute",
    Relative = "Relative"
}
export enum RepertoireAssignmentStatus {
    InProgress = "InProgress",
    Recommended = "Recommended",
    Requested = "Requested",
    Completed = "Completed"
}
export enum ReportFormat {
    PDF = "PDF",
    CSV = "CSV",
    TXT = "TXT",
    VCD = "VCD",
    ZIP = "ZIP"
}
export enum ReportType {
    Invoice = "Invoice",
    InvoiceByCharge = "InvoiceByCharge",
    InvoiceBundle = "InvoiceBundle",
    IncomeReport = "IncomeReport",
    ExpenseReport = "ExpenseReport",
    IncomeExpenseReport = "IncomeExpenseReport",
    Repertoire = "Repertoire",
    ContactList = "ContactList",
    MembershipReceipt = "MembershipReceipt",
    Agenda = "Agenda",
    Mileage = "Mileage",
    LessonsTaught = "LessonsTaught",
    BillableHours = "BillableHours",
    Calendar = "Calendar",
    SalesTax = "SalesTax",
    PracticeSummary = "PracticeSummary",
    FamilyAccountBalance = "FamilyAccountBalance",
    Payroll = "Payroll",
    StudentTaxReceipt = "StudentTaxReceipt",
    AttendanceNote = "AttendanceNote",
    MakeUpCredits = "MakeUpCredits",
    WeekCalendar = "WeekCalendar",
    StudentAttendance = "StudentAttendance",
    InvoiceDetails = "InvoiceDetails",
    HoursTaught = "HoursTaught",
    StudentRetentionRate = "StudentRetentionRate",
    StudentDetails = "StudentDetails",
    EventProfit = "EventProfit",
    LendingLibrary = "LendingLibrary",
    LendingLibraryHistory = "LendingLibraryHistory",
    PaymentReceipt = "PaymentReceipt",
    ReportBundle = "ReportBundle"
}
export enum ReportStatus {
    Completed = "Completed",
    Failed = "Failed",
    Processing = "Processing",
    Emailing = "Emailing"
}
export enum RevenueAndExpenseReportBasis {
    Accrual = "Accrual",
    Cash = "Cash"
}
export enum RevenueAndExpenseReportDetailLevel {
    Itemized = "Itemized",
    Summary = "Summary"
}
export enum RevenueAndExpenseReportSortBy {
    Category = "Category",
    Date = "Date",
    Payee = "Payee",
    PaymentType = "PaymentType"
}
export enum ReviewSentiment {
    Neutral = "Neutral",
    Positive = "Positive",
    Negative = "Negative"
}
export enum ReviewStatus {
    Pending = "Pending",
    ReviewedNotShared = "ReviewedNotShared",
    ReviewedShared = "ReviewedShared"
}
export enum ReviewSharingOption {
    AdminOnly = "AdminOnly",
    PublicNamed = "PublicNamed",
    PublicAnonymous = "PublicAnonymous"
}
export enum SocialMediaLinkType {
    Facebook = "Facebook",
    Twitter = "Twitter",
    Instagram = "Instagram",
    LinkedIn = "LinkedIn",
    YouTube = "YouTube",
    TikTok = "TikTok",
    Threads = "Threads",
    Bluesky = "Bluesky",
    Weibo = "Weibo",
    Bilibili = "Bilibili",
    Xiaohongshu = "Xiaohongshu",
    Other = "Other"
}
export enum SPFResult {
    Misconfigured = "Misconfigured",
    HardFail = "HardFail",
    SoftFail = "SoftFail",
    Neutral = "Neutral",
    Pass = "Pass"
}
export enum SMSProvider {
    Integrated = "Integrated",
    Webhook = "Webhook"
}
export enum SMSTemplateType {
    Reminder = "Reminder",
    Invoice = "Invoice",
    InvoiceReminder = "InvoiceReminder",
    Payment = "Payment",
    Refund = "Refund",
    AutoPayFailed = "AutoPayFailed",
    CancelledEvent = "CancelledEvent"
}
export enum StudentImportColumn {
    StudentFirstName = "StudentFirstName",
    StudentLastName = "StudentLastName",
    StudentFullName = "StudentFullName",
    StudentEmailAddress = "StudentEmailAddress",
    StudentPhoneNumber = "StudentPhoneNumber",
    StudentBirthday = "StudentBirthday",
    StudentSubjects = "StudentSubjects",
    StudentStatus = "StudentStatus",
    StudentSchoolName = "StudentSchoolName",
    StudentSkillLevel = "StudentSkillLevel",
    StudentStartDate = "StudentStartDate",
    StudentGender = "StudentGender",
    StudentNotes = "StudentNotes",
    StudentEmailReminder = "StudentEmailReminder",
    StudentSMSReminder = "StudentSMSReminder",
    ParentFirstName = "ParentFirstName",
    ParentLastName = "ParentLastName",
    ParentFullName = "ParentFullName",
    ParentEmailAddress = "ParentEmailAddress",
    ParentMobilePhoneNumber = "ParentMobilePhoneNumber",
    ParentHomePhoneNumber = "ParentHomePhoneNumber",
    ParentWorkPhoneNumber = "ParentWorkPhoneNumber",
    ParentNotes = "ParentNotes",
    Address = "Address",
    Referrer = "Referrer",
    Teachers = "Teachers",
    SendEmailReminders = "SendEmailReminders",
    SendSMSReminders = "SendSMSReminders"
}
export enum StudentPortalHomepage {
    Calendar = "Calendar",
    News = "News",
    Home = "Home"
}
export enum StudentStatus {
    Active = "Active",
    Inactive = "Inactive",
    Waiting = "Waiting",
    Lead = "Lead",
    Trial = "Trial"
}
export enum StudentTypes {
    ChildOnly = "ChildOnly",
    AdultOnly = "AdultOnly",
    ChildOrAdult = "ChildOrAdult"
}
export enum SurchargeType {
    None = "None",
    Percentage = "Percentage",
    Fixed = "Fixed"
}
export enum TagType {
    Group = "Group",
    Subject = "Subject"
}
export enum TeacherImportColumn {
    FirstName = "FirstName",
    LastName = "LastName",
    FullName = "FullName",
    EmailAddress = "EmailAddress",
    PhoneNumber = "PhoneNumber",
    Address = "Address",
    Subjects = "Subjects",
    Notes = "Notes"
}
export enum TeacherMakeupCreditPaymentBehaviour {
    PayWhenMakeupCreditIssued = "PayWhenMakeupCreditIssued",
    PayWhenMakeupCreditUsed = "PayWhenMakeupCreditUsed"
}
export enum TeacherPayrollType {
    None = "None",
    Hourly = "Hourly",
    Percentage = "Percentage"
}
export enum TeacherStatus {
    Active = "Active",
    Inactive = "Inactive"
}
export enum TeacherNamePurpose {
    General = "General",
    Schedule = "Schedule"
}
export enum TimeZoneFormat {
    Windows = "Windows",
    IANA = "IANA"
}
export enum TransactionType {
    Payment = "Payment",
    Discount = "Discount",
    Refund = "Refund",
    Charge = "Charge"
}
export enum WebsiteHostingType {
    ExternallyHosted = "ExternallyHosted",
    ExternalDomain = "ExternalDomain",
    InternalDomain = "InternalDomain"
}
export enum WebsiteTemplate {
    Standard = "Standard",
    Bold = "Bold",
    Minimalistic = "Minimalistic",
    Template1 = "Template1",
    Template2 = "Template2",
    Template3 = "Template3",
    Template4 = "Template4",
    Template5 = "Template5"
}
export enum WebhookEntityType {
    Attendance = "Attendance",
    Student = "Student",
    Family = "Family",
    FamilyBalance = "FamilyBalance",
    Parent = "Parent",
    PaymentSource = "PaymentSource",
    School = "School",
    ExpenseOrRevenue = "ExpenseOrRevenue",
    Invoice = "Invoice",
    Teacher = "Teacher",
    TeacherBalance = "TeacherBalance",
    SentSMSMessage = "SentSMSMessage",
    SentEmailMessage = "SentEmailMessage"
}
export enum WebhookNotificationType {
    Added = "Added",
    Updated = "Updated",
    Deleted = "Deleted"
}
export enum WebsiteSocialLinksLocation {
    All = "All",
    None = "None",
    Header = "Header",
    Footer = "Footer"
}
export enum WebsiteRenderMode {
    Website = "Website",
    Widget = "Widget"
}
export enum WebsiteBlockType {
    SignupForm = "SignupForm",
    TextAndMedia = "TextAndMedia",
    ContactForm = "ContactForm",
    LoginForm = "LoginForm",
    Blog = "Blog",
    Embed = "Embed",
    Reviews = "Reviews"
}
export enum WebsiteBlockTextAndMediaType {
    Default = "Default",
    AccentBackgroundDefault = "AccentBackgroundDefault",
    MediaLeft = "MediaLeft",
    MediaRight = "MediaRight",
    TwoColumn = "TwoColumn",
    MediaLeftTwoColumn = "MediaLeftTwoColumn",
    MediaRightTwoColumn = "MediaRightTwoColumn",
    MediaLeftShadow = "MediaLeftShadow",
    MediaRightShadow = "MediaRightShadow",
    MediaLeftClipped = "MediaLeftClipped",
    MediaRightClipped = "MediaRightClipped",
    Testimonial = "Testimonial",
    AccentBackgroundTestimonial = "AccentBackgroundTestimonial",
    MediaRightTestimonial = "MediaRightTestimonial",
    MediaRightAccentBackgroundTestimonial = "MediaRightAccentBackgroundTestimonial",
    HTML = "HTML",
    HeroNoImage = "HeroNoImage",
    HeroBackgroundImage = "HeroBackgroundImage",
    HeroSquareSideImage = "HeroSquareSideImage",
    HeroClippedSideImage = "HeroClippedSideImage",
    MediaLeftHeroSquareImage = "MediaLeftHeroSquareImage",
    MediaLeftHeroClippedImage = "MediaLeftHeroClippedImage",
    PhotoGalleryCarousel = "PhotoGalleryCarousel",
    PhotoGalleryCarouselOverlay = "PhotoGalleryCarouselOverlay",
    PhotoGalleryGrid = "PhotoGalleryGrid",
    GallerySquareColumn = "GallerySquareColumn",
    GalleryCircleColumn = "GalleryCircleColumn",
    GallerySquareAccentColumn = "GallerySquareAccentColumn",
    GalleryCircleAccentColumn = "GalleryCircleAccentColumn",
    GallerySquareCardColumn = "GallerySquareCardColumn",
    GalleryCircleCardColumn = "GalleryCircleCardColumn",
    CallToActionDefault = "CallToActionDefault",
    CallToActionDescription = "CallToActionDescription",
    CallToActionAccentBackground = "CallToActionAccentBackground",
    CallToActionAccentBackgroundDescription = "CallToActionAccentBackgroundDescription"
}
export enum WebsiteBlockContactFormType {
    Default = "Default",
    AccentBackgroundDefault = "AccentBackgroundDefault",
    MediaLeft = "MediaLeft",
    MediaRight = "MediaRight"
}
export enum WebsiteBlockSignupFormType {
    Default = "Default",
    AccentBackgroundDefault = "AccentBackgroundDefault",
    MediaLeft = "MediaLeft",
    MediaRight = "MediaRight",
    AvailabilityBookingDefault = "AvailabilityBookingDefault",
    AvailabilityBookingAccentBackground = "AvailabilityBookingAccentBackground",
    CalendarBookingDefault = "CalendarBookingDefault",
    CalendarBookingAccentBackground = "CalendarBookingAccentBackground"
}
export enum WebsiteBlockLoginFormType {
    Default = "Default",
    AccentBackgroundDefault = "AccentBackgroundDefault",
    MediaLeft = "MediaLeft",
    MediaRight = "MediaRight"
}
export enum WebsiteBlockEmbedType {
    Default = "Default",
    AccentBackgroundDefault = "AccentBackgroundDefault"
}
export enum WebsiteBlockReviewsType {
    Default = "Default",
    AccentBackgroundDefault = "AccentBackgroundDefault"
}
export enum WebsiteBlockEmbedContentType {
    Map = "Map",
    Video = "Video",
    Custom = "Custom"
}
export enum WebsiteURLValidationResult {
    OK = "OK",
    DuplicateHostname = "DuplicateHostname",
    ReservedHostname = "ReservedHostname",
    ImproperHostname = "ImproperHostname",
    DomainNotFound = "DomainNotFound",
    ARecordFound = "ARecordFound",
    MultipleCNAME = "MultipleCNAME",
    ImproperCNAME = "ImproperCNAME",
    DnssecMisconfigured = "DnssecMisconfigured"
}
